import cn from 'classnames';
import {Form, Formik} from 'formik';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import * as Yup from 'yup';

import moment from 'jalali-moment';
import CustomHeader from '../../../../../components/mazraeKit/headers/homeHeader';
import useGetCountries from '../../../../../services/hookService/getCountries/useGetCountriesList';
import useGetOptionalAttributes from '../../../../../services/hookService/getOptionalAttributes/useGetOptionalAttributes';
import {RootState} from '../../../../../store/redux';
import {addOptionalFormData} from '../../../../../store/redux/advertisementRegisteration';
import {compoentnsFromGenerator} from '../../../../../utilities/formGenerator';
import {createYearFromNowUntilPast} from '../../../../../utilities/helper/formDataConvertor';
import {parseAdditionalData} from '../../../../../utilities/helper/parseAdditionalData';
import {IrrigationAttributesUnits} from '../../../../../utilities/helper/unitGenerator/AmountUnits.config';
import {times_hours} from '../../../../post/utility/__data';
import {gender, validateInitialValueOptionalForm} from '../../constants';
import {IChoosenForm} from '../../types';

function OptionalInfoAR() {
  const state = useSelector(
    (state: RootState) => state.advertisementRegisteration,
  );

  const additionalDataObj = parseAdditionalData(
    state?.sub_brand_data?.additional_data!,
  );

  const currentJalaliYear = moment().jYear();

  const handleInitialValueOptionalForm = () => {
    // Base data from additionalDataObj
    const baseData = additionalDataObj || {};

    if (state?.input_group?.code === 17 && state?.input?.code === 13) {
      const volume_units_1 = IrrigationAttributesUnits[0].map(item => ({
        title: item.title,
        guid: item.value,
      }));
      const volume_units_2 = IrrigationAttributesUnits[1].map(item => ({
        title: item.title,
        guid: item.value,
      }));

      const validatedData = validateInitialValueOptionalForm(
        volume_units_1,
        volume_units_2,
        state?.optionalFormData,
      );

      return {
        ...baseData,
        ...validatedData,
      };
    } else {
      return {
        ...baseData,
        ...(state?.optionalFormData && JSON.parse(state?.optionalFormData)),
      };
    }
  };

  const AddSchema = Yup.object().shape({});
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {countriesLists} = useGetCountries();
  const {attributesData} = useGetOptionalAttributes(state?.input_group?.type);

  const choosenForm: Record<string, IChoosenForm[]> = {
    sale11: [
      {
        data: [
          ...createYearFromNowUntilPast(5).map((item, index) => ({
            guid: item.toString(),
            title: item,
          })),
          {
            guid: 'last',
            title: `قبل از ${createYearFromNowUntilPast(6).slice(-1)}`,
          },
        ],
        name: 'produce_year',
        placeholder: 'تاریخ تولید',
        // schema: {},
        componentType: 'dropBottomSheet',
      },
      {
        data: [1, 2, 3, 4, 5].map((item, index) => ({
          guid: item.toString(),
          title: ` ${index + 1} سال پس از تولید `,
        })),

        name: 'expire_year',
        placeholder: 'تاریخ انقضا',
        // schema: {},
        componentType: 'dropBottomSheet',
      },
      {
        data: countriesLists?.map(item => ({title: item.name, guid: item.id})),
        name: 'producing_country',
        placeholder: 'کشور تولید کننده',
        // schema: {},
        label: '',
        componentType: 'dropBottomSheet',
      },
      {
        name: 'company',
        placeholder: '',
        // schema: {},
        label: 'شرکت تولید کننده',
        componentType: 'optionalSimpleInput',
      },
      {
        data: attributesData?.map(item => ({
          title: item.attribute,
          guid: item.guid,
        })),
        name: 'attributes',
        placeholder: 'ویژگی ها',
        // schema: {},
        label: '',
        componentType: 'multiSelectDropBottomSheet',
      },
    ],
    sale12: [
      {
        data: [
          ...createYearFromNowUntilPast(5).map((item, index) => ({
            guid: item.toString(),
            title: item,
          })),
          {
            guid: 'last',
            title: `قبل از ${createYearFromNowUntilPast(6).slice(-1)}`,
          },
        ],
        name: 'produce_year',
        placeholder: 'تاریخ تولید',
        // schema: {},
        componentType: 'dropBottomSheet',
      },
      {
        data: [1, 2, 3, 4, 5].map((item, index) => ({
          guid: item.toString(),
          title: ` ${index + 1} سال پس از تولید `,
        })),

        name: 'expire_year',
        placeholder: 'تاریخ انقضا',
        // schema: {},
        componentType: 'dropBottomSheet',
      },
      {
        data: countriesLists?.map(item => ({title: item.name, guid: item.id})),
        name: 'producing_country',
        placeholder: 'کشور تولید کننده',
        // schema: {},
        label: '',
        componentType: 'dropBottomSheet',
      },
      {
        name: 'company',
        placeholder: '',
        // schema: {},
        label: 'شرکت تولید کننده',
        componentType: 'optionalSimpleInput',
      },
      {
        data: attributesData?.map(item => ({
          title: item.attribute,
          guid: item.guid,
        })),
        name: 'attributes',
        placeholder: 'ویژگی ها',
        // schema: {},
        label: '',
        componentType: 'multiSelectDropBottomSheet',
      },
    ],
    sale13: [
      {
        data: [
          ...createYearFromNowUntilPast(5).map((item, index) => ({
            guid: item.toString(),
            title: item,
          })),
          {
            guid: 'last',
            title: `قبل از ${createYearFromNowUntilPast(6).slice(-1)}`,
          },
        ],
        name: 'produce_year',
        placeholder: 'تاریخ تولید',
        // schema: {},
        componentType: 'dropBottomSheet',
      },
      {
        data: [1, 2, 3, 4, 5].map((item, index) => ({
          guid: item.toString(),
          title: ` ${index + 1} سال پس از تولید `,
        })),

        name: 'expire_year',
        placeholder: 'تاریخ انقضا',
        // schema: {},
        componentType: 'dropBottomSheet',
      },
      {
        data: countriesLists?.map(item => ({title: item.name, guid: item.id})),
        name: 'producing_country',
        placeholder: 'کشور تولید کننده',
        // schema: {},
        label: '',
        componentType: 'dropBottomSheet',
      },
      {
        name: 'company',
        placeholder: '',
        // schema: {},
        label: 'شرکت تولید کننده',
        componentType: 'optionalSimpleInput',
      },
      {
        data: attributesData?.map(item => ({
          title: item.attribute,
          guid: item.guid,
        })),
        name: 'attributes',
        placeholder: 'ویژگی ها',
        // schema: {},
        label: '',
        componentType: 'multiSelectDropBottomSheet',
      },
    ],
    sale1511: [
      {
        data: [
          ...createYearFromNowUntilPast(5).map((item, index) => ({
            guid: item.toString(),
            title: item,
          })),
          {
            guid: 'last',
            title: `قبل از ${createYearFromNowUntilPast(6).slice(-1)}`,
          },
        ],
        name: 'produce_year',
        placeholder: 'تاریخ تولید',
        // schema: {},
        componentType: 'dropBottomSheet',
      },
      {
        data: countriesLists?.map(item => ({title: item.name, guid: item.id})),
        name: 'producing_country',
        placeholder: 'کشور تولید کننده',
        // schema: {},
        label: '',
        componentType: 'dropBottomSheet',
      },
      {
        data:
          attributesData?.map(item => ({
            title: item.attribute,
            guid: item.guid,
          })) || [],
        name: 'attributes',
        placeholder: 'ویژگی ها',
        // schema: {},
        label: '',
        componentType: 'multiSelectDropBottomSheet',
      },
    ],
    sale1517: [
      {
        data: [
          ...createYearFromNowUntilPast(5).map((item, index) => ({
            guid: item.toString(),
            title: item,
          })),
          {
            guid: 'last',
            title: `قبل از ${createYearFromNowUntilPast(6).slice(-1)}`,
          },
        ],
        name: 'produce_year',
        placeholder: 'تاریخ تولید',
        // schema: {},
        componentType: 'dropBottomSheet',
      },
      {
        name: 'sequence_models',
        placeholder: '',
        // schema: {},
        label: 'مدل دنباله بند',
        componentType: 'optionalSimpleInput',
      },
      {
        data: countriesLists?.map(item => ({title: item.name, guid: item.id})),
        name: 'producing_country',
        placeholder: 'کشور تولید کننده',
        // schema: {},
        label: '',
        componentType: 'dropBottomSheet',
      },
      {
        data:
          attributesData?.map(item => ({
            title: item.attribute,
            guid: item.guid,
          })) || [],
        name: 'attributes',
        placeholder: 'ویژگی ها',
        // schema: {},
        label: '',
        componentType: 'multiSelectDropBottomSheet',
      },
    ],
    sale16: [
      {
        data: [
          ...createYearFromNowUntilPast(5).map((item, index) => ({
            guid: item.toString(),
            title: item,
          })),
          {
            guid: 'last',
            title: `قبل از ${createYearFromNowUntilPast(6).slice(-1)}`,
          },
        ],
        name: 'produce_year',
        placeholder: 'تاریخ تولید',
        // schema: {},
        componentType: 'dropBottomSheet',
        subDesc: `تاریخ تولید باید بین ۱۳۰۰ تا ${currentJalaliYear} باشد`,
      },
      {
        data: countriesLists?.map(item => ({title: item.name, guid: item.id})),
        name: 'producing_country',
        placeholder: 'کشور تولید کننده',
        // schema: {},
        label: '',
        componentType: 'dropBottomSheet',
      },
      {
        data:
          attributesData?.map(item => ({
            title: item.attribute,
            guid: item.guid,
          })) || [],
        name: 'attributes',
        placeholder: 'ویژگی ها',
        // schema: {},
        label: '',
        componentType: 'multiSelectDropBottomSheet',
      },
    ],
    sale1711: [
      {
        data:
          attributesData?.map(item => ({
            title: item.attribute,
            guid: item.guid,
          })) || [],
        name: 'attributes',
        placeholder: 'امکانات زمین',
        // schema: {},
        label: '',
        componentType: 'multiSelectDropBottomSheet',
      },
    ],
    sale1713: [
      {
        name: 'irrigation_volume',
        placeholder: '',
        label: 'حجم آبیاری',
        // schema: {},
        componentType: 'optionalSimpleInput',
      },
      {
        data: IrrigationAttributesUnits[0]?.map(item => ({
          title: item.title,
          guid: item.value,
        })),
        name: 'irrigation_volume_unit',
        placeholder: '',
        // schema: {},
        componentType: 'dropBottomSheetWithRadio',
      },
      {
        data: IrrigationAttributesUnits[1]?.map(item => ({
          title: item.title,
          guid: item.value,
        })),
        name: 'irrigation_volume_time',
        placeholder: '',
        // schema: {},
        componentType: 'dropBottomSheetWithRadio',
      },
    ],
    providedService14: [
      {
        name: 'age',
        placeholder: '',
        // schema: {},
        label: 'سن',
        componentType: 'optionalSimpleInput',
      },
      {
        data: gender?.map(item => ({title: item.title, guid: item.value})),
        name: 'gender',
        placeholder: 'جنسیت',
        // schema: {},
        label: '',
        componentType: 'dropBottomSheetWithRadio',
      },
      {
        name: 'job_experience',
        placeholder: '',
        // schema: {},
        label: 'میزان سابقه کار(سال)',
        componentType: 'optionalSimpleInput',
      },
      {
        data: times_hours?.map(item => ({
          title: item.label,
          guid: item.value as string,
        })),
        name: 'from_hour',
        placeholder: 'از ساعت',
        // schema: {},
        componentType: 'dropBottomSheet',
        generalTitle: 'ساعات فعالیت',
        generalDesc:
          'ساعاتی از روز که قادر به ارائه خدمات خود هستید را مشخص نمایید.',
      },
      {
        data: times_hours?.map(item => ({
          title: item.label,
          guid: item.value as string,
        })),
        name: 'to_hour',
        placeholder: 'تا ساعت',
        // schema: {},
        componentType: 'dropBottomSheet',
      },
    ],
    providedService15: [
      {
        data: [],
        name: 'from_date',
        placeholder: 'از تاریخ',
        // schema: {},
        label: '',
        componentType: 'dateBottomSheet',
        generalTitle: 'زمان آزاد',
        generalDesc:
          'بازه زمانی‌ای که قادر به ارائه خدمات خود هستید را مشخص نمایید.',
        title: 'از تاریخ',
        titleRequired: false,
      },
      {
        data: [],
        name: 'to_date',
        placeholder: 'تا تاریخ',
        // schema: {},
        label: '',
        componentType: 'dateBottomSheet',
        title: 'تا تاریخ',
        titleRequired: false,
      },
      {
        data: [],
        name: 'exclude_holydays',
        placeholder: '',
        // schema: {},
        label: '',
        componentType: 'checkbox',
        title: 'به جز روزهای تعطیل ',
        titleRequired: false,
      },
      {
        data: [],
        name: 'exclude_fridays',
        placeholder: '',
        // schema: {},
        label: '',
        componentType: 'checkbox',
        title: 'به جز جمعه‌ها',
        titleRequired: false,
      },
    ],
    providedRent1711: [
      {
        data:
          attributesData?.map(item => ({
            title: item.attribute,
            guid: item.guid,
          })) || [],
        name: 'attributes',
        placeholder: 'امکانات زمین',
        // schema: {},
        label: '',
        componentType: 'multiSelectDropBottomSheet',
      },
    ],
    providedRent1713: [
      {
        name: 'irrigation_volume',
        placeholder: '',
        label: 'حجم آبیاری',
        // schema: {},

        componentType: 'optionalSimpleInput',
      },
      {
        data: IrrigationAttributesUnits[0]?.map(item => ({
          title: item.title,
          guid: item.value,
        })),
        name: 'irrigation_volume_unit',
        placeholder: '',

        // schema: {},
        componentType: 'dropBottomSheetWithRadio',
      },

      {
        data: IrrigationAttributesUnits[1]?.map(item => ({
          title: item.title,
          guid: item.value,
        })),
        name: 'irrigation_volume_time',
        placeholder: '',
        // schema: {},
        componentType: 'dropBottomSheetWithRadio',
      },
    ],
    providedRent1511: [
      {
        data: [],
        name: 'from_date',
        placeholder: 'از تاریخ',
        // schema: {},
        label: '',
        componentType: 'dateBottomSheet',
        generalTitle: 'زمان آزاد',
        generalDesc:
          'بازه زمانی‌ای که قادر به اجاره ماشین خود هستید را مشخص نمایید.',
        title: 'از تاریخ',
        titleRequired: false,
      },
      {
        data: [],
        name: 'to_date',
        placeholder: 'تا تاریخ',
        // schema: {},
        label: '',
        componentType: 'dateBottomSheet',
        title: 'تا تاریخ',
        titleRequired: false,
      },
      {
        data: [
          ...createYearFromNowUntilPast(5).map((item, index) => ({
            guid: item.toString(),
            title: item,
          })),
          {
            guid: 'last',
            title: `قبل از ${createYearFromNowUntilPast(6).slice(-1)}`,
          },
        ],
        name: 'produce_year',
        placeholder: 'تاریخ تولید',
        // schema: {},
        componentType: 'dropBottomSheet',
      },
      {
        data: countriesLists?.map(item => ({title: item.name, guid: item.id})),
        name: 'producing_country',
        placeholder: 'کشور تولید کننده',
        // schema: {},
        label: '',
        componentType: 'dropBottomSheet',
      },
      {
        data:
          attributesData?.map(item => ({
            title: item.attribute,
            guid: item.guid,
          })) || [],
        name: 'attributes',
        placeholder: 'ویژگی ها',
        // schema: {},
        label: '',
        componentType: 'multiSelectDropBottomSheet',
      },
    ],
    providedRent1517: [
      {
        data: [],
        name: 'from_date',
        placeholder: 'از تاریخ',
        // schema: {},
        label: '',
        componentType: 'dateBottomSheet',
        generalTitle: 'زمان آزاد',
        generalDesc:
          'بازه زمانی‌ای که قادر به اجاره ماشین خود هستید را مشخص نمایید.',
        title: 'از تاریخ',
        titleRequired: false,
      },
      {
        data: [],
        name: 'to_date',
        placeholder: 'تا تاریخ',
        // schema: {},
        label: '',
        componentType: 'dateBottomSheet',
        title: 'تا تاریخ',
        titleRequired: false,
      },
      {
        data: [
          ...createYearFromNowUntilPast(5).map((item, index) => ({
            guid: item.toString(),
            title: item,
          })),
          {
            guid: 'last',
            title: `قبل از ${createYearFromNowUntilPast(6).slice(-1)}`,
          },
        ],
        name: 'produce_year',
        placeholder: 'تاریخ تولید',
        // schema: {},
        componentType: 'dropBottomSheet',
      },
      {
        data: countriesLists?.map(item => ({title: item.name, guid: item.id})),
        name: 'producing_country',
        placeholder: 'کشور تولید کننده',
        // schema: {},
        label: '',
        componentType: 'dropBottomSheet',
      },
      {
        data:
          attributesData?.map(item => ({
            title: item.attribute,
            guid: item.guid,
          })) || [],
        name: 'attributes',
        placeholder: 'ویژگی ها',
        // schema: {},
        label: '',
        componentType: 'multiSelectDropBottomSheet',
      },
    ],
  };

  const choosenFormData = () => {
    if (state?.srs_type && state.input_group) {
      if (state?.srs_type.type === 'sale' || state?.srs_type.type === 'buy') {
        return choosenForm[
          state?.input_group?.code === 17 || state?.input_group?.code === 15
            ? state?.srs_type?.type +
              state?.input_group?.code +
              state?.input?.code
            : state?.srs_type?.type + state?.input_group?.code
        ];
      } else if (
        state?.srs_type.type === 'service' &&
        state?.serviceBottomSheetData
      ) {
        return choosenForm[
          state?.serviceBottomSheetData + state?.input_group?.code
        ];
      } else if (
        state?.srs_type.type === 'rent' &&
        state?.rentBottomSheetData
      ) {
        return choosenForm[
          state?.input_group?.code === 17 || state?.input_group?.code === 15
            ? state?.rentBottomSheetData +
              state?.input_group?.code +
              state?.input?.code
            : state?.rentBottomSheetData + state?.input_group?.code
        ];
      }
    }
  };

  return (
    <div className="flex flex-col h-full">
      <CustomHeader
        title="سایر مشخصات(اختیاری)"
        postComponent={() => (
          <i className="icon-nameClose-remove" onClick={() => navigate(-1)} />
        )}
        titleClass="font-bold"
      />
      <Formik
        initialValues={handleInitialValueOptionalForm()}
        // initialValues={initialValues}
        validationSchema={AddSchema}
        onSubmit={values => {
          dispatch(addOptionalFormData(JSON.stringify(values)));
        }}
      >
        {({setFieldValue, values, errors, isValid, touched}) => {
          return (
            <Form className="flex flex-col justify-between h-full px-3 pb-3">
              <div
                className={cn('flex flex-col w-full gap-3 mt-3', {
                  'flex-row w-full': state?.input_group?.code === 17,
                })}
              >
                {choosenFormData()?.map((item, index) => (
                  <div key={item.name ?? index}>
                    {compoentnsFromGenerator?.[item?.componentType]?.component({
                      data: item.data,
                      onChange: setFieldValue,
                      //@ts-ignore
                      value: values[item?.name],
                      placeholder: item.placeholder,
                      name: item.name,
                      label: item.label,
                      generalTitle: item.generalTitle,
                      generalDesc: item.generalDesc,
                      subDesc: item.subDesc,
                      errors: errors,
                      touched: touched,
                      title: item.title,
                      titleRequired: item.titleRequired,
                      checked:
                        item.name in values &&
                        values[item.name]?.value === 'true'
                          ? true
                          : false,
                      disabled:
                        values.produce_year?.guid === 'last' &&
                        item.name === 'expire_year',
                    })}
                  </div>
                ))}
              </div>
              <button
                className="bg-farm-shop-500 h-[48px] rounded w-full text-white mt-6"
                onClick={() => {
                  dispatch(addOptionalFormData(JSON.stringify(values)));
                  navigate(-1);
                }}
              >
                ذخیره مشخصات
              </button>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

export default OptionalInfoAR;
